import { Component, Input, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { KENDO_GRID } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-launch-app-buttons',
  templateUrl: './launch-app-buttons.component.html',
  styleUrls: ['./launch-app-buttons.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    CommonModule,
    KENDO_GRID,
  ],
})
export class LuanchAppButtonsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  private route = inject(Router);

  @Input() dataItem;
  @Input() showSummaryLink = false;

  rights = [];

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
  }

  launchApp(ev, id, app) {
    ev.preventDefault();
    this.route.navigate([`/case/${app}/${id}/0`]);
  }
}
